'use client';

import {useTranslation} from 'react-i18next';
import {apm} from '@elastic/apm-rum';
import {Button} from 'common/components/button';
import {DownloadIcon} from '@navikt/aksel-icons';

export const DownloadPDFButton = () => {
  const {t} = useTranslation(['common']);

  const onClick = () => {
    apm.startTransaction('Click - download-pdf', 'user-interaction')?.end();
    window.print();
  };

  return (
    <Button variant='secondary' data-transaction-name='download-pdf' icon={DownloadIcon} onClick={onClick}>
      {t('common:downloadPdf')}
    </Button>
  );
};
